module.exports = __webpack_public_path__ + "static/media/logo_positivo_small.cedb20c3.png";